import { ClipboardCheck, Trash2 } from "lucide-react";
import ServizioDetailTemplate from "@/components/servizi/ServizioDetailTemplate";

const SERVIZI = [
  { icon: ClipboardCheck, titolo: "Consulenza, assistenza e formazione", desc: "Supporto alle aziende nella gestione dei rifiuti e degli adempimenti ambientali, con consulenza su RENTRI, normativa e sostenibilità, in conformità al D.M. 59/2023 per i nuovi FIR con vidimazione digitale, e percorsi formativi personalizzati." },
  { icon: Trash2, titolo: "Smaltimento", desc: "Smaltimento sicuro e conforme dei rifiuti, gestione del trasporto autorizzato e conferimento presso impianti autorizzati, con soluzioni efficienti e tracciabili per rifiuti pericolosi e non." },
];

export default function GestioneRifiutiPage() {
  return (
    <ServizioDetailTemplate
      testId="gestione-rifiuti"
      categoriaLabel="Ambiente"
      titolo="Gestione dei rifiuti"
      heroImage="https://images.unsplash.com/photo-1604187351574-c75ca79f5807?w=1400&q=80&auto=format"
      heroImageAlt="Bidone per la raccolta differenziata dei rifiuti con simbolo di riciclo"
      leadText="Supportiamo le aziende nella gestione dei rifiuti e degli adempimenti ambientali."
      introText="Offriamo consulenza su RENTRI, normativa e sostenibilità. In conformità al D.M. 59/2023, che prevede i nuovi FIR con vidimazione digitale tramite RENTRI, affianchiamo le imprese nella corretta gestione documentale e con percorsi formativi personalizzati, orientati alla piena conformità operativa."
      servizi={SERVIZI}
      ctaText="Contatta il nostro ufficio per la gestione dei rifiuti della tua azienda."
      telefoni={["06.68437.606", "06.68437.530"]}
    />
  );
}
